import React, { Fragment } from 'react'
import PagesHeading from '../pages-heding/PagesHeading'
import UpcomingEvents from '../upcoming-events/UpcomingEvents'

const UpcomingEventsPage = (props) => {
  return (
    <Fragment>
        <PagesHeading page_title={props.page_title}></PagesHeading>
        <UpcomingEvents></UpcomingEvents>
    </Fragment>
  )
}

export default UpcomingEventsPage